import { createApp } from 'vue'

import VideoBlock from './VideoBlock.vue'
import AccordionBlock from './AccordionBlock.vue'
import ContactForm from './ContactForm.vue'
import MobileMenu from './MobileMenu.vue'
import MenuButton from './MenuButton.vue'
import SingleContactForm from './SingleContactForm.vue'
import AnimatedCard from './AnimatedCard.vue'
import TestimonialSlider from './TestimonialSlider.vue'
import LogoSlider from './LogoSlider.vue'
import AllNews from './AllNews.vue'
import LanguageSelection from './LanguageSelection.vue'

declare module 'vue' {
  interface HTMLAttributes {
    ariaExpanded?: boolean
    ariaLabel?: string
    tabIndex?: string
  }
}
/**
 * Initializes the ExampleVueComponent by mounting it to the specified element.
 * @param {string | HTMLElement} mountElement - The element or selector where the component will be mounted.
 */
export default function init(mountElement: HTMLElement) {
  const app = createApp({
    components: {
      VideoBlock: VideoBlock,
      AccordionBlock: AccordionBlock,
      ContactForm: ContactForm,
      MobileMenu: MobileMenu,
      MenuButton: MenuButton,
      SingleContactForm: SingleContactForm,
      AnimatedCard: AnimatedCard,
      TestimonialSlider: TestimonialSlider,
      LogoSlider: LogoSlider,
      AllNews: AllNews,
      LanguageSelection: LanguageSelection
    }
  })

  app.mount(mountElement)
}
